import { render, staticRenderFns } from "./ModalAcessoRapido.vue?vue&type=template&id=c3132628&"
import script from "./ModalAcessoRapido.vue?vue&type=script&lang=js&"
export * from "./ModalAcessoRapido.vue?vue&type=script&lang=js&"
import style0 from "./ModalAcessoRapido.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports